module.exports = __webpack_public_path__ + "img/arround-right.46573d5e.svg";